import React, { useEffect, useRef, useState } from "react";
import { USER_ACTIONS_NAV } from "routes/APP_ROUTES";
import { cn } from "helper/Utils";
import { CloseButton, Disclosure, DisclosureButton, DisclosurePanel } from "@headlessui/react";
import InputField from "components/ui/forms/InputField";
import { useForm } from "react-hook-form";
import { useAuth } from "provider/AuthContext";
import { useTranslation } from "react-i18next";
import { useSportsbook } from "provider/SportsbookContext";

const UserSettingsMenu = ({ handleUserSettingMenuItemClick, isDisclosureOpened, setDisclosureOpened, onClose, selectedKey }) => {
  // const [disclosureOpened, setDisclosureOpened] = useState(null);
  const { t } = useTranslation();
  const [isMobile, setIsMobile] = useState(window?.innerWidth <= 768);
  const { logout } = useAuth();
  const { sendMessageToSportsbook } = useSportsbook();
  const { control } = useForm({});

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const userActionNavItems = USER_ACTIONS_NAV();
  return (
    <>
      <style jsx="true">
        {`
          @media screen and (max-width: 768px) {
            .user-settings-sidebar .menu-item-toggler > i {
              transform: rotate(-90deg) !important;
            }
            .user-settings-sidebar .menu-item-toggler[data-open] > i {
              transform: rotate(90deg) !important;
            }
            .user-settings-sidebar .menu-item-toggler[data-open] {
              justify-content: start;
              flex-direction: row-reverse;
              gap: 10px;
              background: rgba(255, 255, 255, 0.01);
            }
            .user-settings-sidebar .menu-item-toggler[data-open] > span i,
            .user-settings-sidebar .menu-item-toggler[data-open] > span svg {
              display: none;
              order: 2;
            }
          }
        `}
      </style>
      <div className="user-settings-sidebar">
        {userActionNavItems.map((item, index) => {
          const isSelectedDisclosure =
            (Array.isArray(item) &&
              item.some((it) => {
                const keyToCompare = typeof selectedKey === "object" ? selectedKey?.key : selectedKey;
                return it?.key === keyToCompare;
              })) ||
            (Array.isArray(item.child) &&
              item.child.some((child) => {
                const keyToCompare = typeof selectedKey === "object" ? selectedKey?.key : selectedKey;
                return child?.key === keyToCompare;
              }));
          return (
            <Disclosure
              as="div"
              key={index}
              className={cn(
                "menu-item focus-within:outline-none md:mb-2 mb-0.5 md:block",
                item.child
                  ? isMobile && (isDisclosureOpened === null || isDisclosureOpened === item.key)
                    ? "block"
                    : "hidden"
                  : !item.child && isDisclosureOpened === item.key
                  ? "block"
                  : !item.child && isDisclosureOpened === null
                  ? "block"
                  : "hidden"
              )}
              defaultOpen={!isMobile ? isSelectedDisclosure : null}
            >
              <>
                {" "}
                <DisclosureButton
                  className={cn(
                    "group bg-white/5 bg-opacity-15 text-white/80  md:h-[53px] h-[42px] w-full px-3 flex justify-between items-center py-2 rounded-md",
                    "data-[hover]:bg-white data-[hover]:bg-opacity-15",
                    item.child ? "menu-item-toggler" : ""
                  )}
                  onClick={() => {
                    if (!item.child) {
                      handleUserSettingMenuItemClick(item.key);
                      onClose();
                    } else {
                      setDisclosureOpened((prev) => (prev === item.key ? null : item.key));
                    }
                  }}
                >
                  <span className="flex justify-center items-center gap-3">
                    {typeof item.icon === "string" && item.icon.startsWith("bc-i") ? <i className={item.icon} /> : item.icon} {item.label}
                  </span>
                  <i className={cn("bc-i-small-arrow-down group-data-[open]:rotate-180 text-[10px]", !item.child ? "!-rotate-90" : "")} />
                </DisclosureButton>
                {item.child && (
                  <DisclosurePanel as="ul" className="md:p-3 md:bg-white/10 md:border-t md:border-white/10 ">
                    {item && item.child
                      ? item.child.map((child) => {
                          const listItemClass = cn(
                            "px-3 md:py-1 py-2 md:rounded-none rounded md:my-0 my-0.5 flex justify-between cursor-pointer text-white/60 hover:text-white text-[12px] md:border-l-2 md:bg-transparent bg-white/15",
                            child?.key === selectedKey?.key || child?.key === selectedKey
                              ? "md:border-l-primary text-white menu-item-bg-gradiant rounded-se rounded-be"
                              : "md:border-l-white/10"
                          );

                          const handleClick = () => {
                            handleUserSettingMenuItemClick(child);
                            if (isMobile) {
                              setDisclosureOpened(null);
                            }
                          };

                          const Element = isMobile ? CloseButton : "li";

                          return (
                            <Element as="li" key={child.key} onClick={handleClick} className={listItemClass}>
                              {child.label}
                            </Element>
                          );
                        })
                      : null}
                  </DisclosurePanel>
                )}
              </>
            </Disclosure>
          );
        })}
      </div>
      <div className="md:p-5">
        <div className="flex gap-2 md:p-3 py-3 md:bg-white/5 rounded">
          <InputField spacing="m-0 w-full" inputClassName="bg-white bg-opacity-[.15]" control={control} name="promoCode" label={t("Promo code")} />
          <button type="button" className="text-[12px] px-4 text-white/30 bg-white bg-opacity-10 rounded uppercase" disabled>
            {t("apply")}
          </button>
        </div>
      </div>
      <button
        className="group bg-white bg-opacity-5 text-white/80  data-[hover]:bg-white data-[hover]:bg-opacity-15 md:h-[53px] h-[45px] w-full px-3 flex justify-between items-center py-2 rounded-md"
        onClick={() => {
          onClose();
          sendMessageToSportsbook({ logout: "" });
          logout();
        }}
      >
        <span className="flex justify-center items-center gap-3 capitalize">
          <i className="bc-i-logout" /> {t("logout")}
        </span>
      </button>
    </>
  );
};

export default UserSettingsMenu;
